import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteLayoutType } from '../../../../../../../common/redux/features/siteConfig/selectors';
import { API_TYPES } from '../../../../../ApiDisplay';
import { EXAMPLE_TYPES } from '../../../../types';
import { ExamplesPresenter } from '../../ExamplesPresenter/ExamplesPresenter';
import { WebhooksExamplesIntro } from './WebhooksExamplesIntro';

export const WebhooksExample = ({ example, displayName, eventType }) => {
  const layoutType = useSelector(selectSiteLayoutType);
  return (
    <React.Fragment>
      {layoutType !== API_TYPES.RPC && (
        <WebhooksExamplesIntro eventType={eventType} />
      )}
      <ExamplesPresenter
        displayName={displayName}
        example={example}
        renderFor={EXAMPLE_TYPES.WEBHOOKS}
      />
    </React.Fragment>
  );
};

WebhooksExample.propTypes = {
  example: PropTypes.any,
};
